export enum ModalCssClassEnum {
    CommonLong = 'custom-modal-class-menu-item modal-type-common-long',
    CommonMedium = 'custom-modal-class-menu-item modal-type-common-medium',
    CommonShort = 'custom-modal-class-menu-item modal-type-common-short',
}